export default __webpack_public_path__ + "static/media/NotoSans-Regular.baf4d1e2.ttf";